import { descriptionSchema, ruleGroupSchema, ruleIdSchema } from 'Components/AddRulePage/schema';
import { getTranslationValidationHandling } from 'Hooks/query-hooks/helper';
import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const advancedRuleValidationSchema = (t: TFunction) => {
    const validationT = getTranslationValidationHandling(t);
    const status = t('Status');

    return Yup.object({
        active: Yup.boolean().required(validationT('required', { field: status })),
        description: descriptionSchema(t, validationT),
        group: ruleGroupSchema(t, validationT),
        priority: Yup.number().min(1).max(99999),
        ruleId: ruleIdSchema(t, validationT),
        isScriptValidated: Yup.bool().oneOf([true])
    });
};
